import { Container } from 'inversify';
import { registerCollections } from './CollectionBinding';
import { registerRepositories } from './RepositoryBinding';
import io, { Socket } from 'socket.io-client';
import { MemoryDb } from 'minimongo';
import Injectables from '../../constant/Injectables';
import KeycloakStore from '../KeycloakStore';
import IntervalManager from '../../util/IntervalManager';

export const InstanceContainer: Container = new Container({ autoBindInjectable: true, defaultScope: 'Singleton' });
export const apiSuffix = '/api';
export const apiUrl = (process.env.REACT_APP_NODE_ENV === 'development' ? 'http://localhost:3500' : window.location.origin) + apiSuffix;
export const socketUrl = process.env.REACT_APP_NODE_ENV === 'development' ? 'http://localhost:3500' : window.location.origin;
export const initContainer = (tenant: string) => {
  const token = KeycloakStore.getKeycloakInstance()?.token;
  const socketHeaders: Record<string, any> = {
    version: 'v1',
    'tenant-id': tenant,
    authorization: token ? `Bearer ${token}` : null,
  };
  const socket: Socket = io(socketUrl, { extraHeaders: socketHeaders, withCredentials: true });
  const localDb: MemoryDb = new MemoryDb();
  InstanceContainer.bind(Injectables.SOCKET_CLIENT).toConstantValue(socket);
  InstanceContainer.bind(Injectables.LOCAL_DB).toConstantValue(localDb);
  InstanceContainer.bind(Injectables.INTERVAL_MANAGER).toConstantValue(new IntervalManager());

  registerCollections();
  registerRepositories();
};
